import { ProductionTypeEnum } from "../../enums";

/** Default production types for produce/both: Geo, plus Hub when hubs logic is enabled in system settings. */
export const getDefaultProductionTypes = (
  enableHubsLogic?: boolean,
): ProductionTypeEnum[] =>
  enableHubsLogic
    ? [ProductionTypeEnum.Geo, ProductionTypeEnum.Hub]
    : [ProductionTypeEnum.Geo];

/** Filter Hub out of produce-type select lists when hubs logic is disabled. */
export const filterProductionTypeSelectItems = <
  TItem extends { value: string | number | boolean },
>(
  items: TItem[],
  enableHubsLogic?: boolean,
): TItem[] =>
  items.filter(
    item => enableHubsLogic || item.value !== ProductionTypeEnum.Hub,
  );
